import type { SVGProps } from 'react';

const SvgCustomerHub = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}>
    <path fill={props.color} d="M15.96 13.955H7.21v1.5h8.75zM7.21 19.075h6.08v1.5H7.21z" />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M3.805 26.89a2.75 2.75 0 0 0 1.945.805h20.5a2.75 2.75 0 0 0 2.75-2.75V7.055a2.75 2.75 0 0 0-2.75-2.75H5.75A2.75 2.75 0 0 0 3 7.055v17.89c0 .73.29 1.429.805 1.945m1.064-1.064c.234.234.55.366.881.369h12.12v-15.78H4.5v14.53c.003.33.135.647.369.881M19.37 10.415v15.78h6.88a1.26 1.26 0 0 0 1.25-1.25v-14.53zM4.869 6.174a1.26 1.26 0 0 1 .881-.369h20.5a1.26 1.26 0 0 1 1.25 1.25v1.86h-23v-1.86a1.26 1.26 0 0 1 .369-.881"
      clipRule="evenodd"
    />
    <path fill={props.color} d="M20.691 23.098h5.559v1.5h-5.559z" />
  </svg>
);

export default SvgCustomerHub;
